import {UsersService} from "../services/UsersService";
import React, {useEffect, useRef, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {userService} from "../services/UserService";
import {Link, useNavigate} from "react-router-dom";
import {setBreadcrumbs, setCreateButton, setSearchHandler, setTitle} from "../actions/main";
import NavFilter from "../components/NavFilter";
import Formatter from "../helpers/formater";
import TableView from "../components/TableView";
import Total from "../components/Total";
import {Toast} from "primereact/toast";
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';


export default function Users(props) {

    const [data, setData] = useState(false);
    const [loading, setLoading] = useState(true);
    const [tab, setTab] = useState(false)
    const [filter, setFilter] = useState({filter: {}});
    const [navOptions, setNavOptions] = useState([
        {query: 'worker', label: 'Пользователи', count: 0},
        {query: 'additional', label: 'Персонал', count: 0},
        {query: '0', label: 'Архив', count: 0}
    ])

    const toast = useRef(null);

    let storageColumns = localStorage.getItem('table-user-list'),
        defaultColumns = [
            {name: 'username', label: 'Имя', selected: true},
            {name: 'position_name', label: 'Должность', selected: true},
            {name: 'phone', label: 'Телефон', selected: true},
            {name: 'email', label: 'Email', selected: true},
            {name: 'birthday', label: 'Дата рождения'},
            {name: 'cart_number', label: 'Номер карты'},
            {name: 'created_at', label: 'Дата добавления'},
            {name: 'updated_at', label: 'Дата обновления'},
            {name: 'crm_access', label: 'Доступ к системе'},
            {name: 'received', label: 'Дата принятия'},
            {name: 'terminated_date', label: 'Дата увольнения'},
            {name: 'departments', label: 'Филиал'},
        ];
    if(storageColumns){
        defaultColumns = JSON.parse(storageColumns)
    }

    const [tableRows, setTableRows] = useState(defaultColumns)


    const userData = useSelector(function (state) {
        return state.auth.userData
    });
    const searchString = useSelector((s) => s.searchString) || ''
    const currentDepartment = useSelector(function (state) {
        return state.currentDepartment
    });

    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(setTitle('Сотрудники'))
        dispatch(setCreateButton('/users/create'))
        dispatch(setSearchHandler(handleSearch))
        dispatch(setBreadcrumbs([
            {link: 'users', label: 'Сотрудники'}
        ]))

    })

    let navigation = useNavigate();

    function updateData(params) {

        UsersService.GetList({...params, ...{expand: 'departments'}}).then((response, h) => {

            if (response.items) {
                setData(response)
                setLoading(false)
            } else {
                toast.current.show({severity:'error', summary: 'Ошибка', detail:'Не удалось загрузить данные.', life: 3000});
            }
        })
    }

    function updateCounters(){
        let tabs = []
        navOptions.map((navItem) => {
            tabs.push(getFilterArray(navItem.query))
        })

        UsersService.GetCount({filters: tabs}).then((result) => {
            result.map((v, k) => {
                navOptions[k].count = v;
                setNavOptions(navOptions)
            })
        })
    }


    useEffect(() => {
        setLoading(true)
        let f = {filter: {...filter.filter, departmentId: userService.GetCurrentDepartment()}};
        setFilter(f)
        updateData(f)
        // if(currentDepartment && currentDepartment > 0) {
        //     updateCounters()
        // }

    }, [currentDepartment])

    useEffect(() => {
        if(filter.filter.departmentId) {
            updateCounters()
        }
    }, [filter, currentDepartment])

    const handlePageClick = (event) => {
        setLoading(true);
        updateData({...filter, page: ++event.selected})
    }

    function getFilterArray(type){
        const newFilter =JSON.parse(JSON.stringify(filter));
        if (type && type !== '0') {
            newFilter.filter.user_type = type;
            // delete newFilter.filter.status;
            newFilter.filter.status = 1;
        } else {
            delete newFilter.filter.user_type
            if (type === '0') {
                newFilter.filter.status = 2
            } else {
                delete newFilter.filter.status;
            }
        }
        return newFilter
    }

    function handleChangeStatus(type) {
        setLoading(true);
        let newFilter = getFilterArray(type)


        setFilter(newFilter);
        setTab(type)
        updateData(newFilter)

    }

    function handleEditUser(id) {
        navigation(`/users/${id}`)
    }

    function handleSearch(e) {

        setLoading(true);
        filter.filter.s = searchString;
        updateData(filter)
        updateCounters()
        e.preventDefault()
    }

    function setTableRowsHandler(data) {
        setTableRows(data)
    }

    const massRowActions = [
        {
            label: 'Удалить',
            icon: 'pi pi-trash',
            action: 'trash'

        },
        {
            'label': 'Перенести в архив',
            icon: 'pi pi-inbox',
            action: 'archive'
        },
        {
            label: 'Восстановить из архива',
            icon: 'pi pi-briefcase',
            action: 'fromArchive'
        },
    ];

    const massActionHandler = (action, ids) => {
        if(action.action === 'trash'){
            confirmDialog({
                message: 'Вы хотите удалить этих пользователей?',
                header: 'Подтвердите удаление',
                icon: 'pi pi-info-circle',
                acceptClassName: 'p-button-danger',
                accept: () => { },
                acceptLabel: 'Удалить выбранных',
                reject: () => {return false},
                rejectLabel: 'Нет'
            });
        }
    }

    const rowActions = [
        {
            'label': 'Редактировать',
            icon: 'pi pi-user-edit',
            command:(e) => {
                navigation('/users/' + e.item.rowId)
            }
        },
        {
            label: 'Перенести в архив',
            icon: 'pi pi-inbox',
            actionName: 'archiveGo',
            command:(e) => {
                UsersService.ChangeUserStatus(e.item.rowId, 2).then((response) => {
                    toast.current.show({severity:'success', summary: 'Выполнено', detail:'Пользователь перемещен в архив.', life: 3000});
                    updateData(filter)
                    updateCounters()
                })
            }
        },
        {
            'label': 'Восстановить из архива',
            icon: 'pi pi-briefcase',
            actionName: 'archiveOut',
            command:(e) => {
                UsersService.ChangeUserStatus(e.item.rowId, 1).then((response) => {
                    toast.current.show({severity:'success', summary: 'Выполнено', detail:'Пользователь восстановлен из архива.', life: 3000});
                    updateData(filter)
                    updateCounters()
                })
            }
        },
        {
            'label': 'Перенести в "Пользователи"',
            icon: 'pi pi-sync',
            actionName: 'toWorker',
            command:(e) => {
                UsersService.ChangeUserType(e.item.rowId, 'worker').then((response) => {
                    toast.current.show({severity:'success', summary: 'Выполнено', detail:'Тип пользователя изменен.', life: 3000});
                    updateData(filter)
                    updateCounters()
                })
            }
        },
        {
            'label': 'Перенести в "Персонал"',
            icon: 'pi pi-sync',
            actionName: 'toAdditional',
            command:(e) => {
                UsersService.ChangeUserType(e.item.rowId, 'additional').then((response) => {
                    toast.current.show({severity:'success', summary: 'Выполнено', detail:'Тип пользователя изменен.', life: 3000});
                    updateData(filter)
                    updateCounters()
                })
            }
        },
        {
            'label': 'Удалить',
            icon: 'pi pi-trash',
            command: (e) => {

                confirmDialog({
                    message: 'Вы хотите удалить этого пользователя?',
                    header: 'Подтвердите удаление',
                    icon: 'pi pi-info-circle',
                    acceptClassName: 'p-button-danger',
                    accept: () => {
                        UsersService.Delete(e.item.rowId).then((response) => {
                            toast.current.show({severity:'success', summary: 'Выполнено', detail:'Пользователь успешно удален.', life: 3000});
                            updateData(filter)
                            updateCounters()
                        })
                    },
                    acceptLabel: 'Да',
                    reject: () => {return false},
                    rejectLabel: 'Нет'
                });
            }
        }
    ];

    const handlerRawActions = (elId) => {
        const currentRow = data.items.find((el) => {
            return el.id === elId
        })

        if(currentRow) {
            rowActions.map((actionRow, k) => {
                actionRow.rowId = elId

                if (actionRow.actionName && actionRow.actionName === 'archiveGo') {
                    actionRow.visible = currentRow.status === 1
                }
                if (actionRow.actionName && actionRow.actionName === 'archiveOut') {
                    actionRow.visible = currentRow.status === 2
                }
                if (actionRow.actionName && actionRow.actionName === 'toAdditional') {
                    actionRow.visible = currentRow.user_type === 'worker' && currentRow.status === 1
                }
                if (actionRow.actionName && actionRow.actionName === 'toWorker') {
                    actionRow.visible = currentRow.user_type === 'additional' && currentRow.status === 1
                }

            })

            return rowActions;
        }
    }


    const tableValue = (propName, el) => {
        switch (propName) {
            case 'username': {
                return (
                    <Link to={'/users/' + el.id} className="d-flex align-items-center">
                        <img className={'img-40 rounded-circle m-r-20'}
                             src={"http://yii2.easytickets.pro" + el.avatar} alt=""/>
                        <div>
                            <span>{el.username}</span>
                            <small className={'d-block text-muted caption'}>ID {el.id}, {el.status === 2 ? 'архив' : (el.user_type === 'worker' ? 'пользователь' : 'персонал')}</small>
                        </div>
                    </Link>
                )
            }
            case 'position_name':
                return (
                    el.position ? el.position.name : ''
                )
            case 'phone':
                return (
                    el.phone_prefix + el.phone
                )
            case 'departments':
                let array = el.departments.map((d) => {
                    return d.name
                })
                return array.join(', ')
            case 'crm_access':
                return Formatter.boolean(el[propName])
            default:

                return (
                    el[propName]
                )
        }
    }


    return (

        <div className={'product-wrapper'}>
            <Toast ref={toast}></Toast>
            <ConfirmDialog />
            <div className="card project-list">
                <div className="row align-items-center">
                    <div className="col overflow-auto">
                        <NavFilter options={navOptions} handleClick={handleChangeStatus} active={tab}
                        />
                    </div>
                    <div className="col-md-5">

                        <div className="d-flex align-items-center">

                        </div>


                    </div>
                </div>
            </div>


            <div className={'card'}>


                <div className="card-body p-0">


                    <TableView id={'user-list'} tableRows={tableRows} data={data} tableValue={tableValue} loading={loading}
                               setTableRows={setTableRowsHandler} handleEdit={handleEditUser} rowActions={rowActions} massRowActions={massRowActions} massActionHander={massActionHandler} rowActionsHandler={handlerRawActions} tableClass={'user-table'}/>

                </div>

            </div>


            <Total data={data} handlePageClick={handlePageClick}/>

        </div>

    )
}